import {
  useMediaQuery,
  Box,
  Typography,
  IconButton,
  TextField,
  CircularProgress,
} from "@mui/material";
import AdminSidebar from "./AdminSidebar";
import { Search } from "@mui/icons-material";
import color from "../../components/utils/Colors";
import EntityList from "../../components/cards/EntityList";
import { useEffect, useMemo, useState } from "react";
import { AdminEntity, fetchAdminFeedback } from "../../services/adminData";

const AdminFeedback = () => {
  const isSmallScreen = useMediaQuery("(max-width:1050px)");
  const [feedbackItems, setFeedbackItems] = useState<AdminEntity[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchAdminFeedback()
      .then(setFeedbackItems)
      .finally(() => setLoading(false));
  }, []);

  const filteredFeedback = useMemo(() => {
    if (!searchQuery.trim()) return feedbackItems;
    const query = searchQuery.toLowerCase();
    return feedbackItems.filter(
      (item) =>
        item.name.toLowerCase().includes(query) ||
        (item.feedback || "").toLowerCase().includes(query) ||
        (item.subject || "").toLowerCase().includes(query),
    );
  }, [feedbackItems, searchQuery]);

  return (
    <Box
      sx={{
        display: "flex",
        backgroundImage: "url('/images/logo 2.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "auto",
        margin: isSmallScreen ? "10px" : "30px",
        marginTop: "0px",
        paddingTop: "20px",
        gap: "3%",
        borderRadius: "10px",
        flexDirection: isSmallScreen ? "column" : "row",
      }}
    >
      <AdminSidebar />

      <Box sx={{ flex: 1, borderRadius: "16px" }}>
        <TextField
          className="input-root2"
          placeholder="Search..."
          size="small"
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
          InputProps={{
            startAdornment: (
              <IconButton>
                <Search />
              </IconButton>
            ),
          }}
          sx={{ width: { xs: "100%", md: "auto" } }}
        />

        <Box
          sx={{
            position: "relative",
            background: color.firstColor,
            borderRadius: "16px",
            height: "fit-content",
            my: 4,
          }}
        >
          <Box
            component="img"
            src="/assets/Welcome Bar.svg"
            alt="Welcome Bar"
            sx={{
              width: "100%",
              height: { xs: 150, sm: 200 },
              objectFit: "contain",
            }}
          />
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              top: { xs: "25%", sm: "20%" },
              left: "3%",
              fontSize: { xs: "56px", sm: "86px" },
              fontWeight: "bold",
            }}
          >
            Feedback
          </Typography>
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              left: "3%",
              top: { xs: "70%", sm: "72%" },
              fontSize: { xs: "14px", sm: "18px" },
            }}
          >
            {feedbackItems.length} feedback item
            {feedbackItems.length === 1 ? "" : "s"} from reviews and support
          </Typography>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" py={6}>
            <CircularProgress sx={{ color: color.firstColor }} />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <EntityList
              entities={filteredFeedback}
              listName="Feedback"
              fieldsConfig={[
                { label: "Feedback", fieldName: "feedback" },
                { label: "Subject", fieldName: "subject" },
              ]}
              showAddButton={false}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AdminFeedback;
